export default __webpack_public_path__ + "static/media/barrelProcess.5d7f9c02.png";